<template>
  <div class="table-container">
    <v-data-table
      :headers="headers"
      :items="studentRequirementList"
      :items-per-page="pagination.pageSize"
      :loading="!studentRequirementProcessed"
      :server-items-length="pagination.totalSize"
      :page="pagination.current"
      :disable-pagination="
        !studentRequirementList || studentRequirementList.length < 1
      "
      :hide-default-header="
        !studentRequirementList || studentRequirementList.length < 1
      "
      :hide-default-footer="
        !studentRequirementList || studentRequirementList.length < 1
      "
      :disable-sort="true"
      item-key="id"
      class="elevation-1"
      @update:options="pageChanged"
    >
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="edit(item)">
          mdi-pencil
        </v-icon>
        <v-icon small class="mr-2" @click="remove(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
          <confirmation-dialog ref="confirm" />

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const ConfirmationDialog = () =>
    import("@/components/common/ConfirmationDialog.vue");
  
export default {
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 100
      },
      studentRequirementList: [],
      showParentPage: true,

      headers: [
        { text: "Actions", value: "actions", align: "end", sortable: false }
      ],
      sort: {
        key: null
      },
      studentId: null
    };
  },
  components: {
            ConfirmationDialog

  },
  computed: {
    ...mapGetters("studentRequirement", [
      "studentRequirementProcessed",
      "getStudentRequirements"
    ])
  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage"
    ]),
    ...mapActions("studentRequirement", [
      "deleteStudentRequirement",
      "fetchStudentRequirements"
    ]),
    view(item) {
      this.$router.push({
        name: "studentRequirementView",
        params: { id: item.id }
      });
    },
    edit(item) {
      this.$router.push({
        name: "studentRequirementEdit",
        params: { id: item.id }
      });
    },
    async remove(item) {
      let confirm = await this.$refs.confirm.open(
        "Confirm Delete",
        "Do you want to delete this studentRequirement?"
      );
      if (confirm) {
        this.deleteStudentRequirement(item.id)
          .then(() => {
            this.addSuccessMessage(
              "studentRequirement was deleted successfully"
            );
            this.getResources();
          })
          .catch(() => {
            this.addErrorMessage("Server response with error ");
          });
      }
    },
    getResources() {
      const params = {
        page:
          this.pagination.pageIndex && this.pagination.pageIndex > 0
            ? this.pagination.pageIndex - 1
            : 0,
        size: this.pagination.pageSize,
        "student.id": this.studentId
      };
      this.fetchStudentRequirements(params)
        .then(response => {
          if (response) {
            this.pagination.totalSize = response.totalElements;
            this.studentRequirementList = response.content;
          }
        })
        .catch(error => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    showParent(show) {
      this.showParentPage = show;
    },
    pageChanged(pagination) {
      this.pagination.pageIndex = pagination.page;
      this.pagination.pageSize = pagination.itemsPerPage;

      this.getResources();
    }
  },
  watch: {
    "pagination.numberRegisterForPage": function() {
      this.pagination.current = -1;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split("/").length;
    const fromDepth = from.path.split("/").length;
    this.showParentPage = toDepth < fromDepth;
    if (this.showParentPage) {
      this.getResources();
    }
    next();
  }
};
</script>
